import QrCode2Icon from '@mui/icons-material/QrCode2'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import KNDetailsPopover from 'components/KNDetailsPopover/KNDetailsPopover'
import KNDetailsPopoverSection from 'components/KNDetailsPopover/KNDetailsPopoverSection'
import usePopoverState from 'components/KNDetailsPopover/usePopoverState'
import { getRouteName } from 'global/helpers/activeRoute'
import { analyticsEvent } from 'global/helpers/analytics'
import { type ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import QRCode from 'react-qr-code'
import { useLocation } from 'react-router-dom'
import type { TripData } from 'screens/TripDashboard/TripDashboard.types'

export interface DecaQrCodeProps {
  trip: TripData
}

const DecaQrCode = ({ trip }: DecaQrCodeProps): ReactElement | null => {
  const { t } = useTranslation()
  const location = useLocation()
  const {
    anchorEl: decaQrCodeAnchorEl,
    open: decaQrCodeOpen,
    handleClick: handleDecaQrCodeClick,
    handleClose: handleDecaQrCodeClose,
  } = usePopoverState()

  const decaUrl = trip.qrToken
    ? new URL(`/deca/${encodeURIComponent(trip.qrToken)}`, globalThis.location.origin).href
    : null

  const handleDecaQrCodeClickWrapper = useCallback((event: React.MouseEvent<HTMLElement>): void => {
    handleDecaQrCodeClick(event)
    analyticsEvent('polestar_cs_trip_deca_qr_popover', [getRouteName(location.pathname)])
  }, [handleDecaQrCodeClick, location.pathname])

  if (!decaUrl) {
    return null
  }

  return (
    <>
      <Tooltip title={t('screens.cs.trip_dashboard.deca_qr')} enterDelay={200} placement="top" arrow>
        <IconButton
          aria-label={t('screens.cs.trip_dashboard.deca_qr')}
          onClick={handleDecaQrCodeClickWrapper}
          size="small"
          color="primary"
          sx={{ padding: 0 }}
        >
          <QrCode2Icon />
        </IconButton>
      </Tooltip>
      <KNDetailsPopover
        open={decaQrCodeOpen}
        onClose={handleDecaQrCodeClose}
        anchorEl={decaQrCodeAnchorEl}
        rightAligned
      >
        <KNDetailsPopoverSection
          header={t('screens.cs.trip_dashboard.deca_qr')}
          items={[
            (
              <Box key="code" sx={{ backgroundColor: 'white.main', padding: 2, marginTop: 1, marginBottom: -1 }}>
                <QRCode value={decaUrl} size={224} level="M" />
              </Box>
            ),
          ]}
        />
      </KNDetailsPopover>
    </>
  )
}

export default DecaQrCode
